import React, { useState } from 'react';

interface JsonCodeBlockProps {
  data: Record<string, any>;
  title?: string;
  defaultExpanded?: boolean;
  className?: string;
}

const JsonCodeBlock: React.FC<JsonCodeBlockProps> = ({
  data,
  title,
  defaultExpanded = false,
  className = '',
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const formattedJson = JSON.stringify(data, null, 2);

  return (
    <div className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`}>
      {(title || !defaultExpanded) && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center justify-between w-full px-6 py-4 text-left hover:bg-gray-50 transition-colors"
        >
          {title && <h4 className="text-sm font-semibold text-gray-900">{title}</h4>}
          {!defaultExpanded && (
            <svg
              className={`h-5 w-5 text-gray-500 transition-transform duration-200 ${
                isExpanded ? 'transform rotate-180' : ''
              }`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          )}
        </button>
      )}

      {isExpanded && (
        <div className="px-6 pb-4">
          <pre className="bg-gray-50 rounded-md p-4 overflow-x-auto text-xs font-mono text-gray-800 border border-gray-200">
            <code>{formattedJson}</code>
          </pre>
        </div>
      )}
    </div>
  );
};

export default JsonCodeBlock;
